<template>
  <v-system-bar window dark app class="text-center" v-if="showEnvironmentSystemBar">
    <v-row justify="center">
      <span>{{ environment ? environment.VUE_APP_ENV_NAME : "" }} Environment</span>
      <slot name="additional-messages"></slot>
    </v-row>
    <v-icon @click="showSystemBar = false">mdi-close</v-icon>
  </v-system-bar>
</template>

<script>
import { isProduction } from "../../utils/environment";

export default {
  name: "EnvironmentSystemBar",
  props: {
    environment: Object
  },
  data: () => ({
    showSystemBar: true
  }),
  computed: {
    showEnvironmentSystemBar() {
      return (
        this.environment &&
        this.environment.VUE_APP_ENV_NAME &&
        this.environment.NODE_ENV &&
        !isProduction(this.environment) &&
        this.showSystemBar
      );
    }
  }
};
</script>
